module.exports = __webpack_public_path__ + "static/media/Arrowdown.a7e518ce.svg";